import {
  AreaItemType,
  type DraggableMetaType,
  type FieldWrapper,
  type MetaDescriptors,
  type ReportField,
} from "../../../../../../../../api/types/svTypes";
import { isAggregation, isMeasure } from "../../../../utilities/fieldsHelper";
import { extractMeta, isValueField } from "../../common/utilities/dropFieldContainerHelper";
import { isReferenceDateField } from "../../common/utilities/isReferenceDateField";
import { isMeasureMeta } from "../../common/utilities/metaUtils";

export const hasReferenceDate = (columns: ReportField[], rows: ReportField[]): boolean => {
  return columns.some((f) => isReferenceDateField(f.meta)) || rows.some((f) => isReferenceDateField(f.meta));
};

export const hasMeasure = (columns: ReportField[], rows: ReportField[]): boolean => {
  return columns.some(isMeasure) || rows.some(isMeasure);
};

export const isAlreadyAdded = (meta: MetaDescriptors, columns: ReportField[], rows: ReportField[]): boolean => {
  return columns.some((f) => f.meta.name === meta.name) || rows.some((f) => f.meta.name === meta.name);
};

export const canDropItemBase = (
  item: FieldWrapper<ReportField> | DraggableMetaType,
  rows: ReportField[],
  columns: ReportField[]
): boolean => {
  const meta = extractMeta(item);
  if (!meta) {
    return false;
  }
  if (isReferenceDateField(meta) && (hasReferenceDate(columns, rows) || hasMeasure(columns, rows))) {
    return false;
  }

  if (isAlreadyAdded(meta, columns, rows)) {
    return false;
  }

  if (isMeasureMeta(meta)) {
    return !hasReferenceDate(columns, rows) && meta.capabilities.isScalar;
  }

  if (item.type === AreaItemType.VALUES) {
    return isValueField(item) && isAggregation(item.field);
  }

  return true;
};
